const topics = [
  { tag: '热门日漫', count: '2.3w', hot: true },
  { tag: '韩漫推荐', count: '1.8w', hot: true },
  { tag: '国漫精选', count: '1.5w', hot: true },
  { tag: '恋爱甜宠', count: '9800', hot: false },
  { tag: '奇幻冒险', count: '8500', hot: false },
  { tag: '热血战斗', count: '1.2w', hot: true },
  { tag: '校园日常', count: '7600', hot: false },
  { tag: '悬疑推理', count: '6200', hot: false },
  { tag: '搞笑喜剧', count: '5400', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            当前站内最受关注的漫画话题标签，找到你感兴趣的方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((t) => (
            <a
              key={t.tag}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200/80'
                  : 'bg-background-200/70 text-foreground-700 hover:bg-background-300/80'
              }`}
            >
              <span>{t.tag}</span>
              <span className="text-xs opacity-60">{t.count}部</span>
              {t.hot && (
                <span className="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}